export enum ChargerProducts {
    Halo1 = 1,
    Halo2 = 3,
    Aura = 4,
    Dawn = 7,
    Luna = 9,
}

export enum MeasurementDeviceProducts {
    AmpGuard = 5,
    Enegic = 6,
    AmpGuard2 = 8,
}

export enum MiscProducts {
    Ray = 2,
}

export const Products = { ...ChargerProducts, ...MeasurementDeviceProducts, ...MiscProducts }
